<h3>{{ 'admin.sond.creer' | traduire }}</h3>
<p style="color:#777; font-size:13px; margin-bottom:16px;">
  {{ 'admin.sond.explication' | traduire }}
</p>

<form class="form-ajout" (ngSubmit)="creerSondage()">
  <label>{{ 'admin.sond.question' | traduire }}</label>
  <input type="text" [(ngModel)]="nouvelleQuestion" name="question"
         [placeholder]="'admin.sond.questionPlaceholder' | traduire">

  <label>{{ 'admin.sond.options' | traduire }}</label>
  <textarea [(ngModel)]="optionsTexte" name="options" rows="4"
            placeholder="Musique arabo-andalouse&#10;Musique électronique&#10;Jazz fusion"></textarea>

  <p class="confirmation" *ngIf="messageConfirmation">{{ messageConfirmation }}</p>

  <button type="submit">{{ 'admin.sond.publierBtn' | traduire }}</button>
</form>

<h3>{{ 'admin.sond.historique' | traduire }}</h3>
<p style="color:#777; font-size:13px; margin-bottom:16px;">
  {{ 'admin.sond.explicationHistorique' | traduire }}
</p>

<div class="table-liste" *ngFor="let s of sondages" style="margin-bottom: 20px; border: 1px solid #eee; border-radius: 6px; padding: 16px;">
  <div style="display:flex; justify-content:space-between; align-items:flex-start;">
    <div>
      <b>{{ s.question }}</b>
      <span *ngIf="s.actif" style="background:#2e7d4f; color:white; font-size:10px; padding:2px 8px; border-radius:999px; margin-left:8px;">{{ 'admin.sond.actif' | traduire }}</span>
      <p style="font-size:12px; color:#888; margin-top:6px;">{{ totalVotes(s) }} {{ 'admin.sond.votesTotal' | traduire }}</p>
    </div>
    <div style="display:flex; gap:8px;">
      <button *ngIf="!s.actif" class="btn-activer" (click)="activer(s)">{{ 'admin.sond.activerBtn' | traduire }}</button>
      <button class="btn-supprimer" (click)="supprimer(s)">{{ 'admin.sond.supprimerBtn' | traduire }}</button>
    </div>
  </div>
  <div class="resultats-options">
    <div class="resultat-ligne" *ngFor="let o of s.options">
      <div class="resultat-entete">
        <span>{{ o.texte }}</span>
        <span>{{ o.nombreVotes }} {{ 'admin.sond.voteUnite' | traduire }} · {{ pourcentageOption(s, o) }}%</span>
      </div>
      <div class="resultat-barre-fond">
        <div class="resultat-barre-remplie" [style.width.%]="pourcentageOption(s, o)"></div>
      </div>
    </div>
  </div>
</div>

<p *ngIf="sondages.length === 0" style="color:#888;">{{ 'admin.sond.vide' | traduire }}</p>
